import { useMemo } from 'react';

import type { PetitionMarqueeCardData } from '../usePetitionMarquee';

import type { MarqueeRows } from './selectMarqueeRows';
import { selectMarqueeRows } from './selectMarqueeRows';

export function useMarqueeRows(petitions: readonly PetitionMarqueeCardData[]): MarqueeRows {
	return useMemo(() => selectMarqueeRows(petitions), [petitions]);
}
